import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';
import { environment } from '../config/cabinet-environment';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private readonly suffix = 'InfinitForm Platform';

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const prefix = environment.PRODUCTION ? '' : `(${environment.ENV_LABEL}) `;
    const title = this.buildTitle(routerState);
    if (title) {
      this.title.setTitle(`${prefix}${title} - ${this.suffix}`);
    } else {
      this.title.setTitle(`${prefix}${this.suffix}`);
    }
  }
}
